<template>
<div class="main-div2">
<v-footer app bottom fixed style="width: 100%;" padless id="footer">
	<div class="footer-bg">
		<b-container>
			<b-row>
				<b-col>
					<b-row>
						<b-col cols=3>
							<img style="width:40px; height:40px; margin:12px;" src="@/assets/images/Cornell.png">
						</b-col>
						<b-col cols=9>
							<div class="cornell-text">
								Cornell University
							</div>
						</b-col>
					</b-row>
				</b-col>
				<b-col>
				</b-col>
				<b-col>
				</b-col>
				<b-col>
					<div class="cornell-text">
						&copy; 2022 Yu Group
					</div>
				</b-col>
			</b-row>
		</b-container>
		<!--
		<div style="width:auto; margin-left:auto; margin-right:auto;text-align:center;">
			<a href="http://www.icmb.cornell.edu/" style="text-decoration:none;color:#333">
				<div style="display:inline-block;vertical-align:middle; ">
					<img style="width:65px; height:65px;" src="@/assets/cornell_seal.png">
				</div>
				<div style="display:inline-block;vertical-align:middle; ">
					<p style="text-align:left;">				
						Cornell University
						<br>
						Weill Institute for Cell and Molecular Biology
					</p>
				</div>
			</a>
			<a href="http://www.yulab.org/resources.shtml" style="text-decoration:none;color:#333">
				<div style="display:inline-block;vertical-align:middle; margin-left:50px;">
					<img style="width:65px; height:65px;" src="@/assets/yu_logo.png">
				</div>
				<div style="display:inline-block;vertical-align:middle; ">
					<p style="text-align:left;">				
						Yu Group
						<br>
						Computational Suite
					</p>
				</div>
			</a>
		</div>
		<div style="text-align:center;font-size:12px;">
			<p style="font-size:12px;">Visit the <a href="http://www.yulab.org" style="text-decoration:none;color:#99ccff"><b>Yu Lab website</b></a> for contact information and for other tools from the Yu Group Computational Suite <br>  © Yu Group 2019-2020</p>
		</div>	
		-->
	</div>
</v-footer>
</div>
</template>


<script>
export default {
    name: 'footer'
}
</script>

<style>
.main-div2 {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	z-index: 1;
}
.bottom_footer {
	height: 50px;
	position: fixed;
}
.footer-bg {
	background-color: #add26b;
}
.cornell-text {
	text-align:center;
	vertical-align: middle;
	margin: 0;
	position: absolute;
	top: 50%;
	-ms-transform: translateY(-50%);
	transform: translateY(-50%);
}
</style>